import React, {FC} from 'react';
import {observer, inject} from 'mobx-react';
import {Row, Col, Tooltip} from '@enos/dpl';
import localeText from '@locale';
import {OrganizationStore} from '~/stores/OrganizationStore';
import store from '../../store';
import './index.less';

type IProps ={
  organizationStore: OrganizationStore;
}

const ProfileExpand: FC<IProps> = ({organizationStore}) => {
  const {showExpandArea, showAdminInfo, setShowExpandArea, setShowAdminInfo} = store;
  const {organizationAdminInfo, getOrganizationAdminInfo} = organizationStore;
  const profileWidth = document.getElementsByClassName('profile')?.[0]?.clientWidth;
  document.body.style.setProperty('--autoWidth', `${profileWidth}px`);

  const adminInfo = (
    <div className='admin-info'>
      <div className='admin-title'>
        {localeText('COMMON.TITLE_ADMIN_INFO')}
      </div>
      <i className='dplicon_wrong_s' onClick={(): void => setShowAdminInfo(false)} />
      <div className='admin-account'>
        <span className='admin-info-title'>{localeText('USER.COLH_ACCT_NO')}</span>
        <span className='admin-info-detail' title={organizationAdminInfo?.name}>{organizationAdminInfo?.name || '-'}</span>
      </div>
      <div className='admin-email'>
        <span className='admin-info-title'>{localeText('USER.COLH_EMAIL')}</span>
        <span className='admin-info-detail' title={organizationAdminInfo?.email}>{organizationAdminInfo?.email || '-'}</span>
      </div>
    </div>
  );

  const toggleExpand = (): void => {
    setShowExpandArea(!showExpandArea);
    setShowAdminInfo(false);
  };


  const getAdminInfo = (): void => {
    getOrganizationAdminInfo();
    setShowAdminInfo(!showAdminInfo);
  };

  return (
    <div className='profile-expand-content'>
      <div className='profile-expand' style={{display: showExpandArea ? 'block' : 'none'}}>
        <div className='profile-expand-items'>
          <Row>
            <Col span={6}>
              <Tooltip title={adminInfo} overlayClassName='show-admin' arrowPointAtCenter visible={showAdminInfo}>
                <div className='expand-item' title={localeText('COMMON.BTN_ADMIN')} onClick={(): void => getAdminInfo()}>
                  <div className={showAdminInfo ? 'active image' : 'image'} />
                  <span className={showAdminInfo ? 'active-admin' : 'admin'}>{localeText('COMMON.BTN_ADMIN')}</span>
                </div>
              </Tooltip>
            </Col>
          </Row>
        </div>
      </div>
      <div className='fix-icon' onClick={(): void => toggleExpand()}>
        {showExpandArea ? <i className='dpl20_caret_up_s' /> : <i className='dpl20_caret_down_s' />}
      </div>
    </div>
  );
};

export default inject('organizationStore')(observer(ProfileExpand));
